/**
 * 广告详情「上一页 / 下一页」导航上下文。
 * 从列表进入详情时写入；同一浏览器标签页刷新后从 sessionStorage 恢复。
 * 离开广告中心或回到列表时清空，避免陈旧数据。
 */

const STORAGE_KEY_PREFIX = "emp_ad_detail_nav:";

let navContext = null;

function normalizeCompanyId(companyId) {
  const id = Number(companyId);
  return Number.isFinite(id) && id > 0 ? id : 0;
}

function storageKey(companyId) {
  return `${STORAGE_KEY_PREFIX}${normalizeCompanyId(companyId)}`;
}

function cloneContext(context) {
  return {
    companyId: normalizeCompanyId(context.companyId),
    serverQuery: { ...(context.serverQuery || {}) },
    pageIndex: context.pageIndex,
    pageSize: context.pageSize,
    indexInPage: context.indexInPage,
    globalIndex: context.globalIndex,
    totalCount: context.totalCount,
    items: context.items.map((item) => ({ ...item })),
  };
}

function persistToSession(companyId, context) {
  const key = storageKey(companyId);
  try {
    if (!context) {
      sessionStorage.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(context));
  } catch (_) {
    // sessionStorage unavailable or quota exceeded — memory-only fallback
  }
}

function readFromSession(companyId) {
  try {
    const raw = sessionStorage.getItem(storageKey(companyId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.totalCount !== "number" || !Array.isArray(parsed.items)) {
      return null;
    }
    return cloneContext(parsed);
  } catch (_) {
    return null;
  }
}

export function setAdDetailNavContext(companyId, context) {
  if (!context || typeof context.totalCount !== "number" || !Array.isArray(context.items)) {
    return;
  }
  navContext = cloneContext({
    companyId: normalizeCompanyId(companyId),
    ...context,
  });
  persistToSession(navContext.companyId, navContext);
}

export function getAdDetailNavContext(companyId) {
  const cid = normalizeCompanyId(companyId);
  if (navContext && navContext.companyId === cid) {
    return navContext;
  }
  const stored = readFromSession(cid);
  if (!stored) return null;
  navContext = stored;
  return navContext;
}

/** 将内存中的导航上下文写回 sessionStorage（上一页/下一页切换后调用） */
export function syncAdDetailNavContext(companyId) {
  const cid = normalizeCompanyId(companyId);
  if (!navContext || navContext.companyId !== cid) return;
  persistToSession(cid, navContext);
}

export function clearAdDetailNavContext() {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(STORAGE_KEY_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch (_) {
    // ignore
  }
  navContext = null;
}
